var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhone2 = function SvgPhone2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59144 10.79C9.03144 13.62 11.3514 15.93 14.1814 17.38L16.3814 15.18C16.6514 14.91 17.0514 14.82 17.4014 14.94C18.5214 15.31 19.7314 15.51 20.9714 15.51C21.5214 15.51 21.9714 15.96 21.9714 16.51V20C21.9714 20.55 21.5214 21 20.9714 21C11.5814 21 3.97144 13.39 3.97144 4C3.97144 3.45 4.42144 3 4.97144 3H8.47144C9.02144 3 9.47144 3.45 9.47144 4C9.47144 5.25 9.67144 6.45 10.0414 7.57C10.1514 7.92 10.0714 8.31 9.79144 8.59L7.59144 10.79Z",
    fill: "#8B90A0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhone2);
export { ForwardRef as ReactComponent };